export class AtomTextShowDetailsComponent implements ng.IComponentOptions {
    public template = '<span translate="e9227c6b-268e-4e4c-8ac7-bd36403f605d"></span>';
}
